import Vue from 'vue';

const success = (response, resolve) => {
  resolve(response);
};

const failed = (error, reject) => {
  reject(error);
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/sms_two_factor_auth/${data.user_id}/send_verification`, data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/smsTwoFactorAuthSetup/sendVerificationToken.js